export class JwtAuth {
    token = '';
    result: boolean = true;
    errors: any;
}